module.exports = __webpack_public_path__ + "img/04.15a4e07d.png";